import React, { useEffect, useState } from "react";
import { apiKey } from "../../../../config/config";
import CartTable2 from "../../../../components/AdminTable/CartTale2";
import MessageCard from "../../../../components/AdminCards/MessageCard";
import axios from "axios";
import { languageHelper } from "../../../../config/helperFunctions";



function DetailedSaleReport() {
  const user = JSON.parse(localStorage.getItem("rms-admin"));
  const [columns] = useState([
    {
      header: languageHelper("SN") || "SN",
      cell: (row) => row.row.index + 1,
    },

    {
      header: languageHelper("Date") || "Date",
      cell: (row) =>
        new Date(row.row.original.created_at).toISOString().split("T")[0],
    },
    {
      header: languageHelper("Reference") || "Reference",
      accessorKey: "sale_no",
    },
    {
      header: languageHelper("Order Type") || "Order Type",
      cell: (order) => order.row.original.order_type.name,
    },
    {
      header: languageHelper("Total Item") || "Total Item",
      accessorKey: "total_items",
    },
    {
      header: languageHelper("Subtotal") || "Subtotal",
      accessorKey: "sub_total",
    },
    {
      header: languageHelper("Discount") || "Discount",
      accessorKey: "total_discount_amount",
    },
    {
      header: languageHelper("Service/Delivery Charges") || "Service/Delivery Charges",
      accessorKey: "delivery_charges",
    },
    {
      header: languageHelper("Vat") || "Vat",
      accessorKey: "vat_amount",
    },
    {
      header: languageHelper("G. Total") || "G. Total",
      accessorKey: "total_payable",
    },
    {
      header: languageHelper("Payment Method") || "Payment Method",
      // accessorKey: "Payment Method",
      cell: (order) => order.row.original.payment.name,
    },
  ]);
  const [data, setData] = useState([]);
  const [users, setUsers] = useState([]);
  const [paymentMethods, setPaymentMethods] = useState([]);
  const [error, setError] = useState(false);
  const [selectedUser, setSelectedUser] = useState();
  const [selectedPayment, setSelectedPayment] = useState();
  const [startDate, setStartDate] = useState();
  const [endDate, setEndDate] = useState();

  const handleUserSelect = (e) => {
    setSelectedUser(e.value);
  };
  const handlePaymentSelect = (e) => {
    setSelectedPayment(e.value);
  };

  const [selectedOutlet, setSelectedOutlet] = useState();
  const handleOutletSelect = (e) => {
    setSelectedOutlet(e.value);
  };

  const selectButton = [
    {
      placeholder: languageHelper("User"),
      options: users,
      onChange: handleUserSelect,
    },
    {
      placeholder: languageHelper("Payment Method"),
      options: paymentMethods,
      onChange: handlePaymentSelect,
    },
  ];

  const footerConfig = {
    "SN": languageHelper("Total") || "Total",
    "Total Item": (rows) =>
      rows.reduce((acc, row) => acc + (row.total_items || 0), 0),
    "Subtotal": (rows) =>
      rows.reduce((acc, row) => acc + (row.sub_total || 0), 0).toFixed(2),
    "Discount": (rows) =>
      rows.reduce((acc, row) => acc + (row.total_discount_amount || 0), 0).toFixed(2),
    "Service/Delivery Charges": (rows) =>
      rows.reduce((acc, row) => acc + (row.delivery_charges || 0), 0).toFixed(2),
    "Vat": (rows) =>
      rows.reduce((acc, row) => acc + (row.vat_amount || 0), 0).toFixed(2),
    "G. Total": (rows) =>
      rows.reduce((acc, row) => acc + (row.total_payable || 0), 0).toFixed(2),
  };

  useEffect(() => {
    axios
      .get(`${apiKey}/api/rms/admin/details-sales-report`, {
        headers: {
          Authorization: `Bearer ${user?.token}`,
        },
        params: {
          outletId: selectedOutlet || user?.user.outlet_id,
          user_id: selectedUser,
          payment_id: selectedPayment,
          start_date: startDate,
          end_date: endDate,
        },
      })
      .then((res) => {
        setData(res.data);
        setError(false);
      })
      .catch((err) => {
        setError(err.response.data.message || "Error occured");
      })
      .finally(() => {});
  }, [
    endDate,
    selectedPayment,
    selectedUser,
    startDate,
    selectedOutlet,
    user?.token,
    user?.user.outlet_id,
  ]);

  useEffect(() => {
    axios
      .get(`${apiKey}/api/rms/admin/user`, {
        headers: {
          Authorization: `Bearer ${user?.token}`,
        },
        params: {
          outletId: user?.user.outlet_id,
        },
      })
      .then((res) => {
        const mappedCustomers = res.data.map((user) => ({
          value: user.id,
          label: user.name,
        }));
        setUsers(mappedCustomers);
        setError(false);
      })
      .catch((err) => {
        setError(err.response.data.message || "Error occured");
      })
      .finally(() => {});
    axios
      .get(`${apiKey}/api/rms/admin/payment_methods`, {
        headers: {
          Authorization: `Bearer ${user?.token}`,
        },
        params: {
          outletId: user?.user.outlet_id,
        },
      })
      .then((res) => {
        const mappedPayments = res.data.map((payment) => ({
          value: payment.id,
          label: payment.name,
        }));
        setPaymentMethods(mappedPayments);
        setError(false);
      })
      .catch((err) => {
        setError(err.response.data.message || "Error occured");
      })
      .finally(() => {});
  }, [user?.token, user?.user.outlet_id]);

  if (error) {
    return <MessageCard error={error} />;
  }

  return (
    <main>
      <CartTable2
        data={data}
        columns={columns}
        heading={languageHelper("Detailed Sale Report")}
        setStartDate={setStartDate}
        setEndDate={setEndDate}
        selectButton={selectButton}
        downloads={true}
        handleOutletSelect={handleOutletSelect}
        showFooter={true}
        footerConfig={footerConfig}
      />
    </main>
  );
}

export default DetailedSaleReport;
